import { render, staticRenderFns } from "./ProjectWorkorderIncentivePaymentAdd.vue?vue&type=template&id=50bfc5eb"
import script from "./ProjectWorkorderIncentivePaymentAdd.vue?vue&type=script&lang=js"
export * from "./ProjectWorkorderIncentivePaymentAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports